import {BrowserRouter, HashRouter, Route, Switch} from "react-router-dom";

// @ts-ignore
import ReactDOM from "react-dom/client";
import React from "react";
import Router from "./router";
import SignIn from "./components/Auth/SingIn";
import Stat from "./pages/Stat";
import SignUp from "./components/Auth/SingUp";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Index from "./components/SoftwarePrinciples";
import AboutUs from "./components/AboutUs";
import ArticlePageWrapper from "./common/ArticlePage/ArticlePageLazy";
import ShopCom from "./components/Shop/index";

// VisitAPI.getRegCount()

// TODO: Add SDKs for Firebase products that you want to use

// https://firebase.google.com/docs/web/setup#available-libraries


// Your web app's Firebase configuration



// Initialize Firebase

// @ts-ignore
const root = ReactDOM.createRoot(document.getElementById('root'));
const App = () => (
    root.render(
    <BrowserRouter >
        <Switch>
            <Route path={'/stat'} component={Stat} />
            <Route path={'/auth/Singin'} component={SignIn} />
            <Route path={'/auth/Signup'} component={SignUp} />
            <Route path="/article/:category/:key" component={ArticlePageWrapper} />
            <Route path="/privacy-policy" component={PrivacyPolicy} />
            <Route path="/software-principles" component={Index}/>
            <Route path="/about-us" component={AboutUs} />
            <Route path="/shop" component={ShopCom} />

            <Route path={'/'} component={Router} />

        </Switch>
    </BrowserRouter>
            )
);
App()
// const App_MOB = () => (
//     root.render(
//     <App/>
//             )
// );
// App_MOB()

